<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex>
                <h1 class="display-1">Vinculación usuario -> vendedor</h1>
                <v-card>
                    <v-card-text>
                        <v-alert :value="true" type="info">
                            Aqui se relaciona el usuario de microsiga con el usuario de la web. A fin tal de que aquellas consultas por
                            vendedor que se realicen contra microsiga se puedan obtener los datos relacionados
                        </v-alert>
                        <v-layout>
                            <v-flex>
                                <v-autocomplete
                                        v-model="d.user_id"
                                        :items="usuarios"
                                        label="Usuario web"
                                        item-value="id"
                                        item-text="name"
                                        :loading="loadingU"
                                        @input="traeVendedorVinculado"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        v-model="d.vendedor_micro_id"
                                        :items="vendedores"
                                        label="Vendedor microsiga"
                                        item-value="A3_COD"
                                        item-text="A3_NOME"
                                        :loading="loadingV"
                                        clearable
                                ></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" :loading="guardando" @click.native="vinculaVendedor">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
                <errores v-model="msj.mostrar" :datos="msj"></errores>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    import {mapActions} from 'vuex'
    import mixinUsers from '../../mixins/auth/users';
    import mixinVend from '../../mixins/micro/vendedores'
    import errores from '../../components/Errores'

    export default {
        name: "vendedor_usuario",
        mixins: [mixinUsers, mixinVend],
        components: {errores},
        data() {
            return {
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: ''
                },
                guardando: false,
                loadingV: false,
                loadingU: false,
                vendedores: [],
                usuarios: [],
                d: {
                    vendedor_micro_id: '',
                    user_id: ''
                }
            }
        },
        mounted() {
            this.getUsuarios();
            this.getVendedores();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            vinculaVendedor() {
                this.guardando = true;
                this.$http.post('users/vincula-vendedor', this.d)
                    .then(r => {
                        this.msj = r.data;
                        this.guardando = false;
                    }, err => {
                        this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                        this.guardando = false;
                    })
            },
            traeVendedorVinculado() {
                this.loadingV = true;
                this.vendedorVinculado(this.d, r => {
                    if (r) {
                        this.d.vendedor_micro_id = r.A3_COD;
                    }
                    this.loadingV = false;
                }, err => {
                    console.log(err);
                    this.loadingV = false;
                });
            },
            getVendedores() {
                this.loadingV = true;
                this.vendedoresList(r => {
                    this.vendedores = r;
                    this.loadingV = false;
                }, err => {
                    console.log(err)
                    this.loadingV = false;
                })
            },
            getUsuarios() {
                this.loadingU = true;
                this.usersList(r => {
                    this.usuarios = r;
                    this.loadingU = false;
                }, err => {
                    console.log(err)
                    this.loadingU = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/usuario_vendedor.vue